import { useState, useEffect } from "react";
import "./CardProdutoPage.css";
import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";
import { useNavigate, useParams } from "react-router-dom";
import VerificaToken from "../../components/utils/VerificaToken";
import CardAddToCar from "./componentes/CardAddToCar/CardAddToCar";
import {
  ehCaixa,
  ehPesoPorPeca,
  getPesoCaixa,
  getPesoPeca,
} from "../../components/utils/produtoVenda";
import ProdutoLoginInfo from "./componentes/ProdutoLoginInfo";
import ProdutoPreco from "./componentes/ProdutoPreco";

export default function CardProdutoPage() {

  const [ehMobile, setEhMobile] = useState(window.innerWidth <= 768);

  const [mostrarAvisoCompleto, setMostrarAvisoCompleto] = useState(false);

  const [produto, setProduto] =
    useState(null);

  const [imagemPrincipal,
    setImagemPrincipal] =
    useState("");

  const [menuOpen,
    setMenuOpen] =
    useState(false);

  const navigate =
    useNavigate();

  const { coditem } =
    useParams();

  const [usuario, setUsuario] = useState({
    login: false,
    codcliente: null,
    tipo: "",
    limitecrdt: 0,
  });

  useEffect(() => {

    function handleResize() {

      setEhMobile(window.innerWidth <= 768);

    }

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener("resize", handleResize);

  }, []);

  useEffect(() => {
    async function verificar() {
      const dados = await VerificaToken();
      setUsuario(dados);
      console.log(dados)
    }

    verificar();
  }, []);
  // console.log(usuario.limitecrdt);
  const ehCNPJ = usuario.login && usuario.tipo === "CNPJ";


  useEffect(() => {
    if (!coditem) return;

    const fetchProduto =
      async () => {
        try {

          const body = {
            coditem: Number(coditem),
          };

          if (ehCNPJ) {
            body.codcliente = usuario.codcliente;
          }

          //  console.log("Body enviado:", body);

          const resProduto = await fetch(
            "https://app.eliandroalimentos.com.br/api/produtos/listar",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(body),
            }
          );

          const produtos =
            await resProduto.json();
          console.log("produto", produto)
          //   console.log("produtos", produtos)

          if (
            produtos &&
            produtos.length > 0
          ) {
            const produtoAtual =
              produtos[0];

            setProduto(
              produtoAtual
            );

            setImagemPrincipal(
              produtoAtual.foto ||
              ""
            );
          }
        } catch (error) {
          console.error(
            "Erro ao carregar produto:",
            error
          );
        }
      };

    fetchProduto();
  }, [
    coditem,
    ehCNPJ,
    usuario.codcliente,
  ]);

  if (!produto) {
    return (
      <div>
        Carregando produto...
      </div>
    );
  }

  const caixa = ehCaixa(produto);

  const pesoCaixa = getPesoCaixa(produto);

  const pesoPeca = getPesoPeca(produto);

  const pesoPorPeca = ehPesoPorPeca(produto);

  const produtoCarrinho = {
    ...produto,
    ehCaixa: caixa,
    pesoCaixa,
    ehPesoPorPeca: pesoPorPeca,
    pesoPeca,
  };

  const precoAtual =
    ehCNPJ &&
      produto.valorunitario != null &&
      Number(produto.valorunitario) < Number(produto.precovenda)
      ? Number(produto.valorunitario)
      : Number(produto.precovenda);

  const valorCaixa =
    precoAtual * pesoCaixa;

  const valorPeca =
    precoAtual * pesoPeca;


  return (
    <>
      <Navbar />

      <TopLinks
        onOpenMenu={() => setMenuOpen(true)}
      />

      <Menu
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
      />

      <div className="cardProdutoPage-page">

        {/* GALERIA */}
        <div className="cardProdutoPage-galeria">

          <div
            className="cardProdutoPage-imagemPrincipal cardProdutoPage-zoomContainer"
            onMouseMove={(e) => {
              const {
                left,
                top,
                width,
                height,
              } =
                e.currentTarget.getBoundingClientRect();

              const x =
                ((e.clientX - left) / width) * 100;

              const y =
                ((e.clientY - top) / height) * 100;

              e.currentTarget.style.setProperty(
                "--zoom-x",
                `${x}%`
              );

              e.currentTarget.style.setProperty(
                "--zoom-y",
                `${y}%`
              );
            }}
          >
            {imagemPrincipal ? (
              <img
                src={imagemPrincipal}
                alt={produto.descricao}
                className="cardProdutoPage-zoomImage"
              />
            ) : (
              <div
                className="cardProdutoPage-semImagem"
                style={{
                  width: "100%",
                  height: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#eee",
                }}
              >
                Sem imagem
              </div>
            )}
          </div>

        </div>

        {/* INFORMAÇÕES */}

        <div className="cardProdutoPage-info">

          <h1>{produto.Descricao}</h1>

          <div className="cardProdutoPage-dados">

            {(() => {

              if (pesoCaixa === 0 && pesoPeca === 0) {
                return (
                  <div>
                    <strong>Peso:</strong>{" "}
                    {Number(produto.quantemb).toLocaleString("pt-BR")} kg
                  </div>
                );
              }

              if (caixa) {
                return (
                  <div>
                    <strong>Unid.:</strong>{" "}
                    CX Qtde:{" "}
                    {pesoCaixa.toLocaleString("pt-BR")} kg
                  </div>
                );
              }

              return (
                <>
                  {pesoCaixa > 0 && (
                    <div>
                      <strong>CX:</strong>{" "}
                      {pesoCaixa.toLocaleString("pt-BR")} kg
                    </div>
                  )}

                  {pesoPeca > 0 && (
                    <div>
                      <strong>Unid.:</strong>{" "}
                      {pesoPeca.toLocaleString("pt-BR")} kg
                    </div>
                  )}
                </>
              );
            })()}

          </div>

          <div className="cardProdutoPage-boxPesoVariavel">

            {Number(produto.corrigepreco) === 1 && (
              <h2>
                Produto com peso variável
              </h2>
            )}

            <p>

              {!ehMobile || mostrarAvisoCompleto ? (

                <>
                  Seu pedido será analisado por nossa equipe antes do faturamento.
                  O valor final poderá sofrer alterações em função do peso efetivo
                  dos produtos e das condições comerciais cadastradas para o
                  cliente. Após a validação, o pedido será faturado conforme as
                  regras comerciais vigentes. A entrega será programada para o
                  próximo dia útil disponível de atendimento em sua região, de
                  acordo com o nosso cronograma de entregas.
                </>

              ) : (

                <>
                  Seu pedido será analisado por nossa equipe antes do faturamento.
                  O valor final poderá sofrer alterações em...
                </>

              )}

            </p>

            <button
              type="button"
              className="cardProdutoPage-verMais"
              onClick={() =>
                setMostrarAvisoCompleto(!mostrarAvisoCompleto)
              }
            >
              {mostrarAvisoCompleto ? "Ver menos" : "Ver mais"}
            </button>

            {caixa && (
              <p className="cardProdutoPage-alertaCaixa">
                <strong>Atenção:</strong> Cada unidade corresponde a uma caixa
                com {pesoCaixa.toLocaleString("pt-BR")} kg.
              </p>
            )}

          </div>

          <div className="cardProdutoPage-precoArea">

            <ProdutoPreco
              mostrarPreco={usuario.login}
              ehCNPJ={ehCNPJ}
              produto={produto}
              caixa={caixa}
              pesoPorPeca={pesoPorPeca}
              valorCaixa={valorCaixa}
              valorPeca={valorPeca}
            />

            {usuario.login && (
              <CardAddToCar
                produto={produtoCarrinho}
                preco={precoAtual}
                limitecrdt={usuario.limitecrdt}
              />
            )}

          </div>

          {!usuario.login && (
            <ProdutoLoginInfo
              onLogin={() => navigate("/login")}
            />
          )}

        </div>

      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}